import React from 'react';
import { useQuery } from '@apollo/client';
import { ROOT_SECTIONS_QUERY, RootSectionsData } from '@/Hooks/useRootSections';
import { Section } from '@/lib/graph-ql';
import { ClickSource } from '@/Pages/Home/Home';
import styles from './styles.module.scss';
import { TileBannerButton } from '../Button';

type Props = {
  onClick?: () => void;
  assets?: {
    id: string;
    sectionLinkTitle?: string;
    tileImage?: {
      uri: string;
    };
    titleImage?: {
      uri: string;
    };
    section?: {
      id?: string;
      home?: {
        path?: string;
      };
    };
  }[];
};

const TilesBanner: React.FC<Props> = ({ assets, onClick }) => {
  const { data } = useQuery<RootSectionsData<Section[]>>(ROOT_SECTIONS_QUERY);

  if (!assets?.length) {
    return null;
  }

  const asset = assets?.[0];
  const sectionId = asset?.section?.id;
  const match = data?.rootSections.find(({ id }) => id === sectionId);

  return (
    <div className={styles.tilesBanner}>
      <div className={styles.tilesBannerContainer}>
        <img className={styles.tilesBannerImage} src={asset?.tileImage?.uri} alt="" />
        <div className={styles.tilesBannerContent}>
          <img className={styles.tilesBannerLogo} src={asset?.titleImage?.uri} alt="" />
          {match && (
            <TileBannerButton
              onClick={onClick}
              to={{
                pathname: match.home.path,
                state: {
                  sectionId: match.id,
                  pageName: match.title,
                  clickSource: ClickSource.RailTile,
                },
              }}
              text={asset?.sectionLinkTitle || 'Explore More'}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default TilesBanner;
